export default "/assets/track-purple.svg";